export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="w-full lg:w-1/2 relative overflow-hidden bg-secondary-50">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20photography%20of%20diverse%20fashion%20accessories%20including%20a%20stylish%20handbag%20elegant%20watch%20designer%20sunglasses%20and%20delicate%20jewelry%20pieces%20arranged%20on%20a%20soft%20dusty%20rose%20pink%20linen%20background%20natural%20daylight%20with%20gentle%20diffused%20shadows%20modern%20luxury%20editorial%20aesthetic%20with%20warm%20coral%20and%20gold%20accents%20sophisticated%20product%20photography%20with%20organic%20composition&width=900&height=700&seq=kakobuy-cta-left-v2&orientation=landscape"
          alt="Kakobuy - stylowe produkty i akcesoria"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
        <div className="absolute top-8 left-8">
          <span className="text-xs font-medium uppercase tracking-widest text-foreground-700 bg-white/80 backdrop-blur-sm px-3 py-1 rounded-full">
            Przejdź do sklepu
          </span>
        </div>
        <div className="absolute bottom-8 left-8">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-none drop-shadow-lg">
            Znajdź
          </h2>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-none mt-1 drop-shadow-lg">
            Swój
          </h2>
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-heading font-black text-white leading-none mt-1 drop-shadow-lg">
            Styl
          </h2>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex flex-col items-center justify-center bg-background-50 px-8 md:px-16 py-14 md:py-20">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 text-center leading-tight">
          Kakobuy Spreadsheet
        </h2>
        <h3 className="text-2xl md:text-3xl font-heading font-light text-foreground-600 text-center mt-2">
          Zacznij Zakupy
        </h3>

        <p className="mt-6 text-sm text-foreground-500 text-center max-w-md leading-relaxed">
          Odkryj tysiące produktów w jednym miejscu. Nasz spreadsheet jest codziennie aktualizowany, abyś zawsze miał dostęp do najnowszych ofert i najlepszych okazji.
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-white font-bold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg shadow-primary-900/15"
        >
          Kakobuy Spreadsheet
          <i className="ri-arrow-right-up-line"></i>
        </a>

        <p className="mt-6 text-xs text-foreground-400">
          Dołącz do tysięcy zadowolonych klientów
        </p>
      </div>
    </section>
  );
}